import { render } from "./ProductChoosableCollectionPreview.vue?vue&type=template&id=61be6840&scoped=true"
import script from "./ProductChoosableCollectionPreview.vue?vue&type=script&lang=js"
export * from "./ProductChoosableCollectionPreview.vue?vue&type=script&lang=js"

import "./ProductChoosableCollectionPreview.vue?vue&type=style&index=0&id=61be6840&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61be6840"]])

export default __exports__